import httpService from "../httpService";

export default {
  findByHcCongViecTrongTamId(hcCongViecTrongTamId) {
    let params = {hcCongViecTrongTamId: hcCongViecTrongTamId};
    return httpService.get("/hcCongViecTrongTamUser/findByHcCongViecTrongTamId", {
      params: params
    });
  }
};



// WEBPACK FOOTER //
// ./src/services/congviectrongtam/hcCVTrongTamUserService.js